import React, { useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface Translations {
  [key: string]: any;
}
const translations: Record<Language, Translations> = {
  es: {
    header: {
      nav: {
        inicio: 'Inicio',
        servicios: 'Servicios',
        nosotros: 'Nosotros',
        garantia: 'Garantía',
        faq: 'FAQ',
        ubicacion: 'Ubicación',
        contacto: 'Contacto'
      },
      whatsapp: 'WhatsApp'
    },
    services: {
      title: 'BENITEZ HANDYMAN CONSTRUCTION',
      subtitle: 'Ubicados en New Carrollton / Hyattsville, MD',
      description: 'Sirviendo Maryland, Washington DC, y Virginia',
      remodeling: {
        title: 'SERVICIOS DE REMODELACIÓN',
        items: [{
          name: 'Fences',
          desc: 'Instalación, reparación, reemplazo — madera, metal, vinilo'
        }, {
          name: 'Masonry',
          desc: 'Paredes de bloque, ladrillo, bases de concreto'
        }, {
          name: 'Roofing',
          desc: 'Instalación, reparación y reemplazo de techos'
        }, {
          name: 'Painting',
          desc: 'Interior y exterior, acabados profesionales'
        }, {
          name: 'Drywall',
          desc: 'Instalación, reparación, textura y acabados'
        }, {
          name: 'Floors',
          desc: 'Instalación de pisos — madera, cerámica, vinilo, laminado'
        }, {
          name: 'Windows',
          desc: 'Instalación y reemplazo de ventanas'
        }]
      },
      restoration: {
        title: 'SERVICIOS DE RESTAURACIÓN',
        items: [{
          name: 'Concreto',
          desc: 'Reparación de grietas, sellado, restauración estructural'
        }, {
          name: 'Ladrillo',
          desc: 'Tuckpointing, reemplazo de ladrillos, limpieza'
        }, {
          name: 'Fence',
          desc: 'Restauración de cercas dañadas o deterioradas'
        }, {
          name: 'Patio',
          desc: 'Restauración completa de patios y áreas exteriores'
        }, {
          name: 'Power Washing',
          desc: 'Limpieza a presión de superficies, fachadas, patios y entradas'
        }, {
          name: 'Caulking',
          desc: 'Sellado de juntas, ventanas, puertas y grietas para protección contra agua y aire'
        }, {
          name: 'Tree Cutting',
          desc: 'Corte, poda y remoción de árboles de forma segura y profesional'
        }, {
          name: 'Gardening',
          desc: 'Diseño, mantenimiento y cuidado de jardines y áreas verdes'
        }, {
          name: 'Driveway',
          desc: 'Instalación, reparación y resellado de entradas vehiculares'
        }, {
          name: 'House & Apartment Cleaning',
          desc: 'Limpieza profesional de casas y apartamentos, profunda o de mantenimiento'
        }]
      }
    },
    carousel: {
      title: 'Antes y Después',
      subtitle: 'Resultados reales. Sin filtros. Trabajo garantizado.',
      labels: ['Deck / Terraza', 'Power Washing', 'Remodelación de Baño', 'Concreto / Entrada', 'Pisos / Floors']
    },
    opening: {
      p1: 'Hay algo que ningún propietario te dice abiertamente...',
      p2: 'Pero todos lo piensan cuando ven esa pared dañada, ese techo que gotea, ese fence que se está cayendo:',
      quote: '"¿Cuándo lo voy a poder arreglar? ¿Y a quién puedo confiarle mi casa?"',
      p3: 'No es solo dinero. Es tu inversión más grande. Es el lugar donde llegan tus hijos. Es la primera cosa que la gente ve cuando pasan por tu calle.',
      p4: 'Y lo peor no es el daño en sí mismo — lo peor es haberle dado dinero a alguien que prometió arreglarlo... y nunca terminó el trabajo.',
      highlight: 'Eso se acaba hoy.'
    },
    pain: {
      title: 'El Error Que Cometen Miles de Propietarios',
      p1: 'Todos los años, miles de propietarios en Maryland, DC y Virginia cometen el mismo error.',
      p2: 'Ven el daño. Saben que hay que arreglarlo. Y deciden esperar.',
      quotes: ['"Lo hago el próximo mes."', '"Cuando tenga más tiempo."', '"Cuando consiga a alguien de confianza."'],
      p3: 'Y mientras esperan... ese pequeño crack en el concreto se vuelve una grieta. Esa gotera en el techo destruye el drywall. Ese fence inclinado termina en el piso.',
      cost_before: 'Lo que costaba ',
      cost_300: '$300',
      cost_mid: ' arreglar en enero, ahora cuesta ',
      cost_1200: '$1,200',
      cost_after: ' en junio.',
      p4: 'Y encima de eso — encontraste a alguien, le pagaste el depósito, y... desapareció. O hizo el trabajo a medias. O simplemente hizo lo mínimo para cobrar y irse.',
      p5: 'Sabemos que ya pasaste por eso. La mayoría de la gente que nos llama ha pasado por eso.'
    },
    emotional: {
      title: 'Tu Casa Merece Respeto',
      p1: 'Tu casa no es solo una estructura. Es el resultado de años de trabajo. De sacrificio. De madrugar, trasnochar, y hacer lo que sea necesario para tener algo propio en este país.',
      highlight: 'Merece ser tratada con respeto.',
      p2: 'Merece un contratista que llegue cuando dice que llega. Que use materiales de calidad. Que te explique exactamente qué va a hacer y cuánto va a costar — ',
      p2_strong: 'sin sorpresas al final.',
      p3: 'Y merece a alguien que entienda tu comunidad, porque vive y trabaja en ella.'
    },
    dream: {
      title: 'Imagina Esto...',
      p1: 'Llegas a tu casa un viernes por la noche y el piso nuevo brilla. El fence está perfecto. La pared que llevaba meses rota ya no existe. El techo sellado. El patio restaurado.',
      highlight1: 'Tus vecinos lo notan. Tu familia lo nota. ',
      highlight2: 'Tú lo notas.',
      p2: 'No solo cambió el aspecto de tu propiedad — cambió cómo te sientes al entrar por esa puerta.',
      p3: 'Eso es lo que hace un trabajo bien hecho. Y eso es lo que ',
      p3_strong: 'BENITEZ HANDYMAN CONSTRUCTION',
      p3_end: ' te puede dar.'
    },
    whyFail: {
      title: 'Por Qué Los Otros Fallan',
      subtitle: 'Hemos escuchado las mismas historias cientos de veces:',
      items: [{
        title: 'El contratista barato',
        desc: 'que usó materiales de segunda y el trabajo duró 6 meses'
      }, {
        title: 'La empresa grande',
        desc: 'que mandó a alguien diferente cada día, sin coordinación'
      }, {
        title: 'El "amigo de un amigo"',
        desc: 'que cobró adelantado y nunca terminó'
      }, {
        title: 'El que no hablaba español',
        desc: 'y había malentendidos en todo el proceso'
      }],
      conclusion1: 'El problema no es solo la mano de obra — es la ',
      conclusion1_strong: 'falta de compromiso personal.',
      conclusion2: 'Cuando el dueño no es el que trabaja, nadie le importa tu casa tanto como a ti.'
    },
    mechanism: {
      pretitle: 'Esto es lo que hace diferente a BENITEZ:',
      title: 'El Sistema de Manos Confiables',
      p1: ' — el dueño — está involucrado personalmente en cada trabajo.',
      p1_strong: 'Geovanny',
      p2: 'No hay intermediarios. No hay subcontratistas anónimos. No hay excusas.',
      points: ['Un solo punto de contacto — Geovanny directamente', 'Presupuesto claro antes de empezar', 'Disponible 24/7 para emergencias y seguimiento', 'Trabajo local — conocemos MD, DC y VA', 'Satisfacción garantizada antes del pago final']
    },
    story: {
      title: 'La Historia de Geovanny',
      p1: 'Geovanny Benítez no empezó con una oficina grande ni con un equipo de 50 personas.',
      p2: 'Empezó con sus manos, sus herramientas, y una promesa simple:',
      quote: '"Si le doy mi palabra a alguien, lo cumplo."',
      p3: 'Esa filosofía construyó ',
      p3_strong: 'BENITEZ HANDYMAN CONSTRUCTION',
      p3_end: ' proyecto por proyecto, casa por casa, familia por familia en la región de DC, Maryland y Virginia.',
      p4: 'Hoy, después de años de trabajo en esta comunidad, nuestro nombre se pasa de boca en boca — no porque hagamos publicidad cara — sino porque ',
      p4_strong: 'cada trabajo habla por sí mismo.'
    },
    benefits: {
      title: 'Beneficios Traducidos a Tu Vida Real',
      header1: 'Beneficio del Servicio',
      header2: 'Lo que Significa Para Ti',
      items: [{
        feature: 'Disponibilidad 24/7',
        benefit: 'Emergencias atendidas — sin esperar días'
      }, {
        feature: 'Geovanny supervisa personalmente',
        benefit: 'Tranquilidad de que el trabajo se hace bien'
      }, {
        feature: 'Presupuesto claro',
        benefit: 'Sin sorpresas. Sin costos ocultos'
      }, {
        feature: 'Servicios múltiples',
        benefit: 'Un solo contratista para todo — menos estrés'
      }, {
        feature: 'Local en Hyattsville/New Carrollton',
        benefit: 'Conocen tu área, están cerca, llegan rápido'
      }, {
        feature: 'Experiencia en remodelación Y restauración',
        benefit: 'No solo arreglan — transforman'
      }]
    },
    risk: {
      title: 'Nuestra Promesa Es Simple',
      p1: 'Si no quedas satisfecho con el trabajo antes del pago final — ',
      p1_strong: 'lo corregimos.',
      p2: 'Sin argumentos. Sin excusas.',
      p3: 'Tu tranquilidad no es un extra — es parte del servicio.'
    },
    urgency: {
      title: 'Espacios Limitados Cada Mes',
      p1_strong: 'Importante:',
      p1: ' Geovanny trabaja con un número limitado de proyectos cada mes para garantizar calidad y atención personal.',
      p2: 'No somos una empresa que toma 30 proyectos a la vez y manda a cualquiera.',
      highlight1: 'Cuando el calendario está lleno — ',
      highlight2: 'está lleno.',
      p3: 'Si tienes un proyecto en mente, ',
      p3_strong: 'contacta hoy',
      p3_end: ' para reservar tu lugar antes de que la lista se cierre.',
      button: 'Reservar Mi Lugar Ahora'
    },
    cta: {
      badge: 'Respuesta en Minutos',
      title1: '¿LISTO PARA TRANSFORMAR',
      title2: 'TU PROPIEDAD?',
      p1: 'Llama o Escribe Ahora a',
      p2: 'Geovanny Benítez',
      available: 'Disponible 24/7',
      location: 'New Carrollton / Hyattsville, Maryland',
      quote1: '"La primera llamada no cuesta nada. El daño que ignoras — ',
      quote2: 'sí.',
      quote3: '"'
    },
    oneLiners: {
      title: 'Lo Que Nos Define',
      quotes: ['Tu casa habla. Nosotros nos aseguramos de que diga lo correcto.', 'No vendemos promesas. Vendemos resultados que se pueden tocar.', 'Disponibles cuando otros están dormidos.', 'Un trabajo mal hecho no es ahorro — es deuda disfrazada.', 'Geovanny no manda a nadie. Geovanny va.', 'Tu inversión merece manos que la cuiden.', '24/7 no es un slogan. Es nuestro teléfono prendido a las 2AM.', 'De Hyattsville para toda la región — calidad que se queda.', 'No arreglamos paredes. Restauramos hogares.', 'El mejor momento para arreglarlo fue ayer. El segundo mejor es ahora.']
    },
    faq: {
      title: 'Preguntas Frecuentes',
      items: [{
        q: '¿Son licenciados?',
        a: 'Trabajamos profesionalmente en MD, DC y VA con años de experiencia comprobable en la comunidad.'
      }, {
        q: '¿Cómo sé que van a terminar el trabajo?',
        a: 'Geovanny supervisa personalmente cada proyecto — no se va hasta que quedes satisfecho.'
      }, {
        q: '¿Tienen precios altos?',
        a: 'Damos presupuestos claros antes de empezar. Sin sorpresas. Comparamos favorablemente con el mercado.'
      }, {
        q: '¿Pueden hacer trabajos pequeños?',
        a: 'Sí. Desde una pared hasta una remodelación completa — todo tiene atención.'
      }, {
        q: '¿Atienden los fines de semana?',
        a: '24/7 significa todos los días, incluyendo fines de semana y emergencias.'
      }, {
        q: '¿Hablan español?',
        a: 'Sí. 100%. Comunicación clara en tu idioma.'
      }]
    },
    map: {
      title: 'Nuestra Ubicación',
      p1: 'Ubicados en ',
      p1_strong: 'New Carrollton / Hyattsville, MD',
      p1_end: ' — Sirviendo toda la región de Maryland, Washington DC y Virginia.',
      available: 'Disponible 24/7 para toda la región'
    },
    footer: {
      description: 'Trabajo hecho con orgullo, por alguien que da la cara.',
      contact: 'Contacto',
      serviceArea: 'Área de Servicio:',
      base: 'Base: New Carrollton / Hyattsville',
      availability: 'Disponibilidad: ',
      services: 'Servicios',
      serviceList: ['Remodelación Completa', 'Restauración Estructural', 'Fences & Roofing', 'Masonry & Concreto', 'Pintura & Drywall'],
      backToTop: 'Volver Arriba',
      rights: 'Todos los derechos reservados.'
    },
    toast: {
      in: 'en',
      requested: 'solicitó',
      ago: 'Hace',
      minutes: 'minutos',
      free: 'GRATIS',
      service: 'Servicio'
    }
  },
  en: {
    header: {
      nav: {
        inicio: 'Home',
        servicios: 'Services',
        nosotros: 'About Us',
        garantia: 'Guarantee',
        faq: 'FAQ',
        ubicacion: 'Location',
        contacto: 'Contact'
      },
      whatsapp: 'WhatsApp'
    },
    services: {
      title: 'BENITEZ HANDYMAN CONSTRUCTION',
      subtitle: 'Located in New Carrollton / Hyattsville, MD',
      description: 'Serving Maryland, Washington DC, and Virginia',
      remodeling: {
        title: 'REMODELING SERVICES',
        items: [{
          name: 'Fences',
          desc: 'Installation, repair, replacement — wood, metal, vinyl'
        }, {
          name: 'Masonry',
          desc: 'Block walls, brick, concrete foundations'
        }, {
          name: 'Roofing',
          desc: 'Roof installation, repair and replacement'
        }, {
          name: 'Painting',
          desc: 'Interior and exterior, professional finishes'
        }, {
          name: 'Drywall',
          desc: 'Installation, repair, texture and finishes'
        }, {
          name: 'Floors',
          desc: 'Floor installation — wood, ceramic, vinyl, laminate'
        }, {
          name: 'Windows',
          desc: 'Window installation and replacement'
        }]
      },
      restoration: {
        title: 'RESTORATION SERVICES',
        items: [{
          name: 'Concrete',
          desc: 'Crack repair, sealing, structural restoration'
        }, {
          name: 'Brick',
          desc: 'Tuckpointing, brick replacement, cleaning'
        }, {
          name: 'Fence',
          desc: 'Restoration of damaged or deteriorated fences'
        }, {
          name: 'Patio',
          desc: 'Complete restoration of patios and outdoor areas'
        }, {
          name: 'Power Washing',
          desc: 'Pressure washing of surfaces, facades, patios and driveways'
        }, {
          name: 'Caulking',
          desc: 'Joint, window, door and crack sealing for water and air protection'
        }, {
          name: 'Tree Cutting',
          desc: 'Safe and professional tree cutting, trimming and removal'
        }, {
          name: 'Gardening',
          desc: 'Garden design, maintenance and landscaping care'
        }, {
          name: 'Driveway',
          desc: 'Driveway installation, repair and resealing'
        }, {
          name: 'House & Apartment Cleaning',
          desc: 'Professional house and apartment cleaning, deep or maintenance'
        }]
      }
    },
    carousel: {
      title: 'Before & After',
      subtitle: 'Real results. No filters. Guaranteed work.',
      labels: ['Deck / Terrace', 'Power Washing', 'Bathroom Remodeling', 'Concrete / Driveway', 'Floors']
    },
    opening: {
      p1: 'There is something no homeowner tells you openly...',
      p2: 'But everyone thinks it when they see that damaged wall, that leaking roof, that falling fence:',
      quote: '"When will I be able to fix it? And who can I trust with my house?"',
      p3: "It's not just money. It's your biggest investment. It's the place where your children arrive. It's the first thing people see when they drive down your street.",
      p4: "And the worst part isn't the damage itself — the worst part is having given money to someone who promised to fix it... and never finished the job.",
      highlight: 'That ends today.'
    },
    pain: {
      title: 'The Mistake Thousands of Homeowners Make',
      p1: 'Every year, thousands of homeowners in Maryland, DC and Virginia make the same mistake.',
      p2: 'They see the damage. They know it needs to be fixed. And they decide to wait.',
      quotes: ['"I\'ll do it next month."', '"When I have more time."', '"When I find someone I trust."'],
      p3: 'And while they wait... that small crack in the concrete becomes a fissure. That leak in the roof destroys the drywall. That leaning fence ends up on the ground.',
      cost_before: 'What cost ',
      cost_300: '$300',
      cost_mid: ' to fix in January, now costs ',
      cost_1200: '$1,200',
      cost_after: ' in June.',
      p4: 'And on top of that — you found someone, paid them the deposit, and... they disappeared. Or did half the job. Or just did the bare minimum to get paid and leave.',
      p5: "We know you've been through that. Most of the people who call us have been through that."
    },
    emotional: {
      title: 'Your Home Deserves Respect',
      p1: "Your house is not just a structure. It's the result of years of hard work. Of sacrifice. Of waking up early, staying up late, and doing whatever it takes to own something in this country.",
      highlight: 'It deserves to be treated with respect.',
      p2: "It deserves a contractor who shows up when they say they will. Who uses quality materials. Who explains exactly what they're going to do and how much it will cost — ",
      p2_strong: 'no surprises at the end.',
      p3: 'And it deserves someone who understands your community, because they live and work in it.'
    },
    dream: {
      title: 'Imagine This...',
      p1: 'You come home on a Friday night and the new floor shines. The fence is perfect. The wall that was broken for months no longer exists. The roof is sealed. The patio is restored.',
      highlight1: 'Your neighbors notice. Your family notices. ',
      highlight2: 'You notice.',
      p2: 'Not only did the look of your property change — it changed how you feel walking through that door.',
      p3: "That's what a job well done does. And that's what ",
      p3_strong: 'BENITEZ HANDYMAN CONSTRUCTION',
      p3_end: ' can give you.'
    },
    whyFail: {
      title: 'Why Others Fail',
      subtitle: "We've heard the same stories hundreds of times:",
      items: [{
        title: 'The cheap contractor',
        desc: 'who used second-rate materials and the job lasted 6 months'
      }, {
        title: 'The big company',
        desc: 'that sent someone different every day, with no coordination'
      }, {
        title: 'The "friend of a friend"',
        desc: 'who charged upfront and never finished'
      }, {
        title: "The one who didn't speak English",
        desc: 'and there were misunderstandings throughout the process'
      }],
      conclusion1: "The problem isn't just the labor — it's the ",
      conclusion1_strong: 'lack of personal commitment.',
      conclusion2: "When the owner isn't the one working, nobody cares about your house as much as you do."
    },
    mechanism: {
      pretitle: 'Here is what makes BENITEZ different:',
      title: 'The Trusted Hands System',
      p1: ' — the owner — is personally involved in every job.',
      p1_strong: 'Geovanny',
      p2: 'No middlemen. No anonymous subcontractors. No excuses.',
      points: ['A single point of contact — Geovanny directly', 'Clear estimate before starting', 'Available 24/7 for emergencies and follow-ups', 'Local work — we know MD, DC and VA', 'Satisfaction guaranteed before final payment']
    },
    story: {
      title: "Geovanny's Story",
      p1: "Geovanny Benítez didn't start with a big office or a team of 50 people.",
      p2: 'He started with his hands, his tools, and a simple promise:',
      quote: '"If I give someone my word, I keep it."',
      p3: 'That philosophy built ',
      p3_strong: 'BENITEZ HANDYMAN CONSTRUCTION',
      p3_end: ' project by project, house by house, family by family in the DC, Maryland and Virginia region.',
      p4: 'Today, after years of working in this community, our name spreads by word of mouth — not because we run expensive ads — but because ',
      p4_strong: 'every job speaks for itself.'
    },
    benefits: {
      title: 'Benefits Translated to Your Real Life',
      header1: 'Service Benefit',
      header2: 'What It Means For You',
      items: [{
        feature: '24/7 Availability',
        benefit: 'Emergencies handled — without waiting days'
      }, {
        feature: 'Geovanny supervises personally',
        benefit: 'Peace of mind that the job is done right'
      }, {
        feature: 'Clear estimate',
        benefit: 'No surprises. No hidden costs'
      }, {
        feature: 'Multiple services',
        benefit: 'One contractor for everything — less stress'
      }, {
        feature: 'Local in Hyattsville/New Carrollton',
        benefit: 'They know your area, are close, arrive fast'
      }, {
        feature: 'Experience in remodeling AND restoration',
        benefit: "They don't just fix — they transform"
      }]
    },
    risk: {
      title: 'Our Promise Is Simple',
      p1: 'If you are not satisfied with the work before the final payment — ',
      p1_strong: 'we fix it.',
      p2: 'No arguments. No excuses.',
      p3: "Your peace of mind isn't an extra — it's part of the service."
    },
    urgency: {
      title: 'Limited Spots Every Month',
      p1_strong: 'Important:',
      p1: ' Geovanny works with a limited number of projects each month to guarantee quality and personal attention.',
      p2: 'We are not a company that takes 30 projects at once and sends just anyone.',
      highlight1: 'When the schedule is full — ',
      highlight2: "it's full.",
      p3: 'If you have a project in mind, ',
      p3_strong: 'contact us today',
      p3_end: ' to reserve your spot before the list closes.',
      button: 'Reserve My Spot Now'
    },
    cta: {
      badge: 'Response in Minutes',
      title1: 'READY TO TRANSFORM',
      title2: 'YOUR PROPERTY?',
      p1: 'Call or Text Now to',
      p2: 'Geovanny Benítez',
      available: 'Available 24/7',
      location: 'New Carrollton / Hyattsville, Maryland',
      quote1: '"The first call costs nothing. The damage you ignore — ',
      quote2: 'does.',
      quote3: '"'
    },
    oneLiners: {
      title: 'What Defines Us',
      quotes: ['Your house speaks. We make sure it says the right thing.', "We don't sell promises. We sell results you can touch.", 'Available when others are asleep.', "A job poorly done isn't savings — it's disguised debt.", "Geovanny doesn't send anyone. Geovanny goes.", 'Your investment deserves hands that care for it.', "24/7 is not a slogan. It's our phone on at 2AM.", 'From Hyattsville to the whole region — quality that stays.', "We don't fix walls. We restore homes.", 'The best time to fix it was yesterday. The second best is now.']
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [{
        q: 'Are you licensed?',
        a: 'We work professionally in MD, DC and VA with years of verifiable experience in the community.'
      }, {
        q: 'How do I know you will finish the job?',
        a: "Geovanny personally supervises every project — he doesn't leave until you are satisfied."
      }, {
        q: 'Are your prices high?',
        a: 'We give clear estimates before starting. No surprises. We compare favorably with the market.'
      }, {
        q: 'Can you do small jobs?',
        a: 'Yes. From a wall to a complete remodel — everything gets attention.'
      }, {
        q: 'Do you work on weekends?',
        a: '24/7 means every day, including weekends and emergencies.'
      }, {
        q: 'Do you speak English?',
        a: 'Yes. 100%. Clear communication in your language.'
      }]
    },
    map: {
      title: 'Our Location',
      p1: 'Located in ',
      p1_strong: 'New Carrollton / Hyattsville, MD',
      p1_end: ' — Serving the entire region of Maryland, Washington DC and Virginia.',
      available: 'Available 24/7 for the entire region'
    },
    footer: {
      description: 'Work done with pride, by someone who stands behind it.',
      contact: 'Contact',
      serviceArea: 'Service Area:',
      base: 'Base: New Carrollton / Hyattsville',
      availability: 'Availability: ',
      services: 'Services',
      serviceList: ['Complete Remodeling', 'Structural Restoration', 'Fences & Roofing', 'Masonry & Concrete', 'Painting & Drywall'],
      backToTop: 'Back to Top',
      rights: 'All rights reserved.'
    },
    toast: {
      in: 'in',
      requested: 'requested',
      ago: 'Ago',
      minutes: 'minutes',
      free: 'FREE',
      service: 'Service'
    }
  }
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('es');
  const t = (key: string) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key; // Fallback to key if not found
      }
    }
    return value;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-385">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}